import { createFileRoute } from "@tanstack/react-router";
import { loadLocations } from "common/apis/search";
import { buildSearchApiParams } from "@/lib/searchParams";
import { homePinsQueryKey } from "common/hooks/business/home/homePinsQueryKey";
import { searchParamsSchema } from "@/lib/searchParamsSchema";
import { SearchErrorBoundary } from "@/components/Search/SearchErrorBoundary";

const isProduction =
  import.meta.env.VITE_APPLICATION_ENVIRONMENT === "Production";

export const Route = createFileRoute("/search")({
  ssr: "data-only",
  validateSearch: searchParamsSchema,
  loaderDeps: ({ search }) => ({ search }),
  loader: async ({ context, deps: { search } }) => {
    const params = buildSearchApiParams(search);
    const accessToken = undefined;
    const canonicalOrigin =
      (typeof process !== "undefined" && process.env?.PUBLIC_ORIGIN) || "";

    try {
      const results = await loadLocations(accessToken, {
        ...params,
        unixTimestamp: Math.floor(Date.now() / 1000),
      });

      context.queryClient.setQueryData(
        homePinsQueryKey(params, accessToken),
        results,
      );

      return { results, query: search.query || "", canonicalOrigin };
    } catch {
      return { results: null, query: search.query || "", canonicalOrigin };
    }
  },
  head: ({ loaderData }) => ({
    meta: [
      { title: loaderData?.query ? `Search: ${loaderData.query}` : "Search" },
      ...(!isProduction
        ? [{ name: "robots", content: "noindex, nofollow" }]
        : [{ name: "robots", content: "noindex, follow" }]),
    ],
    links: [
      {
        rel: "canonical",
        href: `${loaderData?.canonicalOrigin ?? ""}/search`,
      },
    ],
  }),
  errorComponent: SearchErrorBoundary,
});
